<template>
<div>
  <DataNavigation></DataNavigation>
  <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel"></VipPrompt>
  <div class="index_content">
    <Layout>
      <Sider width="208">
        <div class="right_column">
          <p class="top-tip">行业宏观数据</p>
          <div class="keyword-input">
            <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch($event)" />
          </div>
          <div class="rigit_title">
            <span>筛选</span>
            <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
              <a href="javascript:void(0)">
                <span>{{screen_active}}</span>
                <Icon type="md-arrow-dropup" v-if="drop_val" />
                <Icon type="md-arrow-dropdown" v-else />
              </a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="rigit_content">
            <div class="screen_ul">
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '领域选择'">
                <div class="screen_tle" @click="screenTle.tags = !screenTle.tags">
                  <span>领域选择</span>
                  <Icon type="md-add" v-if="!screenTle.tags" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.tags">
                  <ul class="scr_attention">
                      <!-- @on-change="handleChangeOption($event, 'tags')" -->
                    <CheckboxGroup v-model="params.tags" @on-change="handleChangeOption($event, 'tags')">
                      <li v-for="tItem in dynview_tag_type" :key="tItem.id">
                        <div class="scr_att_tle">
                          <Icon type="md-arrow-dropright" v-if="!screen_sec[tItem.id]" @click="haddleSecSel(tItem.id)" />
                          <Icon type="md-arrow-dropdown" v-else @click="haddleSecSel(tItem.id)" />
                          <span @click="haddleSecSel(tItem.id)">{{tItem.name}}</span>
                        </div>
                        <div class="scr_att_cnt" v-show="screen_sec[tItem.id]">
                          <Checkbox v-for="item in hot_tag_map" :label="item.id" :key="item.id" v-if="item.type_id === tItem.id">
                            <span>{{item.name}}</span>
                          </Checkbox>
                        </div>
                      </li>
                    </CheckboxGroup>
                  </ul>
                </div>
              </div>
              <!-- <div class="screen_li" v-show="screen_active === '全部' || screen_active === '项目名称'">
                <div class="screen_tle" @click="screenTle.name = !screenTle.name">
                  <span>项目名称</span>
                  <Icon type="md-add" v-if="!screenTle.name" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.name">
                  <RadioGroup v-model="params.name" vertical  @on-change="clearGetList($event, true)">
                    <Radio label=""><span>不限</span></Radio>
                    <Radio v-for="item,index in hy_name" :label="item" :key="index" v-show="index < 10 || showAllName"><span>{{item}}</span></Radio>
                  </RadioGroup>
                  <span class="more_sel" @click="showAllName = !showAllName">
                      <template v-if="!showAllName">查看更多</template>
                      <template v-else>收起更多</template>
                  </span>
                </div>
              </div> -->
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '数据类别'">
                <div class="screen_tle" @click="screenTle.classification = !screenTle.classification">
                    <span>数据类别</span>
                    <Icon type="md-add" v-if="!screenTle.classification" />
                    <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.classification">
                    <!-- <RadioGroup v-model="params.classification" vertical @on-change="clearGetList($event,true)">
                        <Radio label=""><span>不限</span></Radio>
                        <Radio v-for="item,index in hy_classification" :label="item" :key="index"><span>{{item}}</span></Radio>
                    </RadioGroup> -->
                    <ul class="scr_attention">
                      <RadioGroup v-model="params.classification" @on-change="clearGetList">
                        <li v-for="item,index in hy_classification" :key="index">
                          <div class="scr_att_tle">
                            <Icon type="md-arrow-dropright" v-if="!screen_hy_sec[item.id]" @click="haddleHySecSel(item.id)" />
                            <Icon type="md-arrow-dropdown" v-else @click="haddleHySecSel(item.id)" />
                            <span @click="haddleHySecSel(item.id)">{{item.value}}</span>
                          </div>
                          <div class="scr_att_cnt" v-show="screen_hy_sec[item.id]">
                            <Radio v-for="item1 in hy_feature" :label="item.value+','+item1.value" :key="item1.id" v-if="isInRelation(item.id, item1.id)">
                              <span>{{item1.value}}</span>
                            </Radio>
                          </div>
                        </li>
                      </RadioGroup>
                    </ul>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '地区选择'">
                <div class="screen_tle" @click="screenTle.address = !screenTle.address">
                    <span>地区选择</span>
                    <Icon type="md-add" v-if="!screenTle.address" />
                    <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.address">
                    <RadioGroup v-model="params.address" vertical @on-change="clearGetList">
                        <Radio label=""><span>不限</span></Radio>
                        <Radio v-for="item,index in hy_address" :label="item" :key="index" v-show="index < 10 || showAllAddress"><span>{{item}}</span></Radio>
                    </RadioGroup>
                    <span class="more_sel" @click="showAllAddress = !showAllAddress" v-if="hy_address.length>10">
                        <template v-if="!showAllAddress">查看更多</template>
                        <template v-else>收起更多</template>
                    </span>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '时间选择'">
                <div class="screen_tle" @click="screenTle.compute_date = !screenTle.compute_date">
                    <span>时间选择</span>
                    <Icon type="md-add" v-if="!screenTle.compute_date" />
                    <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.compute_date">
                    <RadioGroup v-model="params.compute_date" vertical @on-change="clearGetList">
                        <Radio label=""><span>不限</span></Radio>
                        <Radio v-for="item,index in hy_year" :label="item" :key="index"><span>{{item}}</span></Radio>
                    </RadioGroup>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Sider>
      <Content>
        <div class="top-tip">全部
          <Dropdown @on-click="haddleChangeSort">
            <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
          <div class="sel_tle">已选条件</div>
          <div class="sel_cnt">
            <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
              <Icon type="md-close" />
            </span>
          </div>
          <div class="sel_clear">
            <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
          </div>
        </div>
        <div class="list_div">
          <Table :columns="listColumns" :data="listData"></Table>
          <OrgPrompt which="hgsj" v-if="listData.length == 5"></OrgPrompt>
          <!-- <template v-else>
            <div class="page clear" v-if="total > 10">
              <Page :total="total" :page-size="10" :current="params.page" class="page_list" show-total show-elevator ref="pages" @on-change="handleChangePage" />
            </div>
          </template> -->
          <Spin fix v-if="listLoading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </div>
      </Content>
    </Layout>
  </div>
</div>
</template>

<script>
import {
  getHyData
} from '../../service'
import {
  remove
} from 'js/findIndex'
import {
  listMixins
} from 'js/listMixins'
import {
  userInfo
} from 'js/userInfo'
import DataNavigation from './components/DataNavigation.vue'
import OrgPrompt from '@/components/OrgPrompt.vue'
import filter from 'js/filter'
import moment from 'moment'

export default {
  inject: ['login'],
  mixins: [listMixins, userInfo],
  components: {
    DataNavigation,
    OrgPrompt
  },
  data() {
    return {
      listName: '行业数据',
      listColumns: [
        {
          title: '地区',
          width: 80,
          render: (h, params) => {
            return h('span', params.row.address.length == 0 ? '--' : params.row.address[0].value)
          }
        },
        {
          title: '数据类别',
          width: 80,
          render: (h, params) => {
            return h('span', params.row.classification.length == 0 ? '--' : params.row.classification[0].value)
          }
        },
        {
          title: '具体指标',
          width: 90,
          render: (h, params) => {
            return h('span', params.row.feature.length == 0 ? '--' : params.row.feature[0].value)
          }
        },
        {
          title: '项目名称',
          width: 124,
          render: (h, params) => {
            return h('span', params.row.name.length == 0 ? '--' : params.row.name[0].value)
          }
        },
        {
          title: '年份',
          width: 62,
          render: (h, params) => {
            return h('span', filter.empty(params.row.compute_date.year))
          }
        },
        {
          title: '数值',
          width: 74,
          render: (h, params) => {
            return h('span', filter.amountJustPrecise(params.row.value))
          }
        },
        {
          title: '单位',
          width: 50,
          render: (h, params) => {
            return h('span', !params.row.decoration ? '--' : params.row.decoration)
          }
        },
        {
          title: '是否预估',
          width: 76,
          render: (h, params) => {
            return h('span', params.row.evaluation ? '是' : '否')
          }
        },
        {
          title: '数据来源',
          width: 98,
          render: (h, params) => {
            return h('span', params.row.organization.length == 0 ? '--' : params.row.organization[0].value)
          }
        },
        {
          title: '报告名称',
          width: 146,
          render: (h, params) => {
            return h('span', params.row.src.file.name)
          }
        },
        {
          title: '相关文件',
          render: (h, params) => {
            if (params.row.src.file.report_file_path) {
              return h('a', {
                attrs:{
                  href: this.$store.state.static_pdf_url + params.row.src.file.report_file_path.substr(1),
                  download: params.row.src.file.name,
                  target: '_blank'
                },
                class: {upload_ico: true},
              }, [
                h('i', {class: {iconfont: true}, domProps: {innerHTML: '&#xe644;'}}),
                h('span','下载')
              ])
            } else {
              return h('span', '暂无')
            }
          }
        }
      ],
      params: {
        sort_type: '1',
        page: 1,
        fetch_size: 0,
        name: '',
        tags:[],
        classification: '',
        address: '',
        compute_date: '',
        keyword: ''
      },
      screen_dropdown: ['全部', '领域选择', '数据类别', '地区选择','时间选择'],
      //筛选条件是否展开
      screenTle: {
        tags: false,
        classification: false,
        address: false,
        compute_date: false,
        name: false
      },
      showAllAddress: false,
      showAllName: false,

      checkAll: {
        tags: true
      },

      sort_id: 0,
      sort_list: [
        {id: 0, name: '更新时间倒序'},
        {id: 1, name: '更新时间正序'}
      ],

    //   数组

      hy_address: [],
      hy_classification: [],
      hy_feature: [],
      hy_name: [],
      hy_organization: [],
      hy_year: [],
      hy_class_feature_relation: [],
      screen_hy_sec: {}
    }
  },
  computed: {
    haveOption() {
       let optionTag = [],
        optionName = [],
        optionClassification = [],
        optionAddress = [],
        optionKeyword = [],
        optionComputeDate = []
      this.params.tags.map((a) => {
        optionTag.push({
          type: 'tags',
          name: filter.dealName(a, this.hot_tag_map),
          value: a
        })
      })
      if (this.params.name) {
        optionName = {
          type: 'name',
          name: this.params.name,
          value: this.params.name
        }
      }
      if (this.params.classification) {
        optionClassification = {
          type: 'classification',
          name: this.params.classification,
          value: this.params.classification
        }
      }
      if (this.params.address) {
        optionAddress = {
          type: 'address',
          name: this.params.address,
          value: this.params.address
        }
      }
      if (this.params.keyword) {
        optionKeyword = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword
        }
      }
      if (this.params.compute_date) {
        optionComputeDate = {
          type: 'compute_date',
          name: this.params.compute_date,
          value: this.params.compute_date
        }
      }

      return [].concat(
        optionTag,
        optionName,
        optionClassification,
        optionAddress,
        optionKeyword,
        optionComputeDate
      )
    }
  },
  methods: {
    /**
     * 获取公司列表
     */
    async getEntityList() {
      this.params.sort_type = this.sort_id
      this.params.user_key = this.user_key
      this.listLoading = true
      let temp_params =  {
        sort_type: this.params.sort_type,
        page: this.params.page,
        fetch_size: 1,
        name: {q: this.params.name},
        tags:this.params.tags.reduce((val, item) => { 
            val.push(this.hot_tag_map.find(h => h.id == item))
            return val
        }, []),
        feature: {q: this.params.classification.indexOf(',') != -1 ? this.params.classification.split(',')[1]: ''},
        address: {q: this.params.address},
        compute_date: {year: this.params.compute_date},
        value: this.params.keyword
      }
      let res = await getHyData(temp_params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'listData', res.res)
        if (this.params.page == 1) {
            this.$set(this.$data, 'total', res.count)
        }
        this.listLoading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption() {
      this.params = {
        sort_type: '1',
        page: 1,
        fetch_size: 0,
        name: '',
        tags:[],
        classification: '',
        address: '',
        compute_date: '',
        keyword: ''
      }
      this.search_ipt = ''
      this.params.page = 1
      this.getEntityList()
    },
    haddleHySecSel(item_id) { // 行业数据二级
      this.screen_hy_sec[item_id] = !this.screen_hy_sec[item_id]
      this.$forceUpdate()
    },
    isInRelation(f_id, c_id) {
      return this['hy_class_feature_relation'].find(item => f_id == item.classification_id && c_id == item.feature_id)
    }
  },
  created() {
    this.getMeta(true)
    this.getMeta2(['hydata_class_value', 'dynview_tag_type'], () => {
        Object.keys(this.meta.hydata_class_value).forEach((key) => {
          if(key=='classification' || key=='feature' || key=='class_feature_relation') {
            this['hy_'+key] = this.meta.hydata_class_value[key]
          } else {
            this['hy_'+key] = this.meta.hydata_class_value[key].map(item => item.value)
          }
        })
        for(let i=moment().format('YYYY');i>=2015;i--) {
            this.hy_year.push(i)
        }
        this.dynview_tag_type = this.meta.dynview_tag_type
    })
    this.getEntityList()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 10)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 10)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    // this.$store.commit('updateOrgParams', this.params)
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/dataList.stylus'
.scr_att_cnt
  >>>.ivu-radio-wrapper
    width: -webkit-fill-available
    width: -moz-available
</style>
